import React from 'react';
import { useThemeColors } from '../../hooks/useTheme';
import './Experience.scss';

const experience = [
  {
    id: 1,
    role: "Full-Stack & DevOps Engineer",
    company: "Thoughtline Technologies, Technopark, TVM, Kerala",
    period: "Jan 2022 – Present",
    description: [
      "Spearheaded the development and maintenance of responsive web and mobile applications using Angular, React.js, and React Native",
      "Engineered scalable CI/CD pipelines using Azure DevOps and AWS CodePipeline",
      "Managed infrastructure provisioning and deployment using Terraform, CloudFormation, Docker and Kubernetes",
      "Administered Linux-based servers and implemented secure cloud deployments on AWS and Azure",
      "Integrated real-time application monitoring with Grafana, Prometheus, and ELK Stack",
      "Designed and implemented Salesforce integrations for CRM-driven workflows",
      "Led cross-functional teams in Agile and Scrum environments"
    ]
  },
  {
    id: 2,
    role: "Junior Software Engineer Trainee",
    company: "Amba Tex Global Private Ltd., Tiruppur, Tamil Nadu",
    period: "Jan 2021 – Dec 2021",
    description: [
      "Developed and maintained ERP, CRM, e-commerce, and BI applications",
      "Designed and managed UI/UX components using Photoshop and Illustrator",
      "Integrated and tested Java, HTML, and Salesforce interfaces",
      "Provided technical support and troubleshooting",
      "Performed code reviews and implemented best practices"
    ]
  },
  {
    id: 3,
    role: "Quality Engineer Trainee",
    company: "Bharat Heavy Electricals Limited, Trichy, Tamil Nadu",
    period: "Nov 2019 – Dec 2020",
    description: [
      "Prepared NDT data reports for boiler drum super heater panels and valves",
      "Managed QA/QC documentation including Inspection Requests and Test Certificates",
      "Reviewed and finalized updated data in SAP and Internal ERP systems",
      "Ensured project compliance with regulatory standards"
    ]
  },
  {
    id: 4,
    role: "Junior Engineer Trainee",
    company: "Apollo Computer Edu Pvt Ltd., Nagercoil, Tamil Nadu",
    period: "May 2019 – Nov 2019",
    description: [
      "Installed and activated required software licenses",
      "Managed incident logs and service requests",
      "Assisted with training and development programs",
      "Created and modified logos, marketing materials, and website graphics",
      "Developed print and digital marketing assets"
    ]
  }
];

const Experience: React.FC = () => {
  const colors = useThemeColors();

  return (
    <section 
      id="experience" 
      className="experience" 
      style={{ 
        backgroundColor: colors.background,
        color: colors.primary
      }}
    >
      <div className="experience__container">
        <h2 className="experience__title">Professional Experience</h2>
        
        <div className="experience__list">
          {experience.map(item => (
            <div 
              key={item.id} 
              className="experience__item"
              style={{
                backgroundColor: colors.surface,
                border: `1px solid ${colors.border}`
              }}
            >
              <div className="experience__header">
                <h3 className="experience__role">{item.role}</h3>
                <div className="experience__meta">
                  <span className="experience__company">{item.company}</span>
                  <span className="experience__period">{item.period}</span>
                </div>
              </div>
              
              <ul className="experience__description">
                {item.description.map((point, index) => (
                  <li key={index} className="experience__point">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;